import z from "zod";
import { PaginationResponseSchema, PaginationSchema } from "../common";
import { ProjectOrderByEnum } from "./common";
import {
  AdminProjectSchema,
  AdminProjectSummarySchema,
  CreateProjectSchema,
  GenerateProjectOverviewSchema,
  SeedProjectSchema,
  TranslateOverviewSchema,
  UpdateProjectSchema,
} from "./entity";
import { ListProjectFilter } from "./filter";

export const AdminProjectSchemas = {
  find: {
    request: z.object({ id: z.uuidv7() }),
    response: AdminProjectSchema,
  },

  findByCode: {
    request: z.object({ code: z.string() }),
    response: AdminProjectSchema,
  },

  list: {
    request: PaginationSchema.extend({
      ...ListProjectFilter.shape,
      orderBy: ProjectOrderByEnum,
      sort: z.string().optional(),
    }),
    response: PaginationResponseSchema(AdminProjectSummarySchema),
  },

  map: {
    request: ListProjectFilter,
    response: z
      .object({ id: z.uuidv7(), code: z.string(), lat: z.number(), lng: z.number(), minPrice: z.number() })
      .array(),
  },

  create: CreateProjectSchema.extend({ draftId: z.uuidv7().optional() }),

  seed: SeedProjectSchema,

  update: UpdateProjectSchema,

  delete: z.object({ id: z.uuidv7() }),

  toggleStatus: z.object({ id: z.uuidv7() }),

  generateOverview: GenerateProjectOverviewSchema,

  translateOverview: TranslateOverviewSchema,
};

export type AdminProject = z.infer<typeof AdminProjectSchema>;

export type ListAdminProjectsRequest = z.infer<typeof AdminProjectSchemas.list.request>;
export type AdminProjectSummary = z.infer<typeof AdminProjectSummarySchema>;

export type CreateProject = z.infer<typeof AdminProjectSchemas.create>;
export type UpdateProject = z.infer<typeof AdminProjectSchemas.update>;

export type GenerateProjectOverview = z.infer<typeof AdminProjectSchemas.generateOverview>;
export type TranslateProjectOverview = z.infer<typeof AdminProjectSchemas.translateOverview>;
